import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreateChecklistItemsInput,
  DeleteChecklistItemsInput,
  UpdateChecklistItemInput,
  UpdateTaskInput,
  UpdateTaskMutation,
} from '@/gql/graphql';

const UPDATE_CHECKLIST_TASK_MUTATION = graphql(`
  mutation UpdateChecklistTask(
    $input: UpdateTaskInput!
    $newChecklistItems: CreateChecklistItemsInput!
    $updateChecklistItems: [UpdateChecklistItemInput!]!
    $deleteChecklistItems: DeleteChecklistItemsInput!
  ) {
    updateTask(input: $input) {
      ... on IEntity {
        id
      }
    }
    createChecklistItems(input: $newChecklistItems) {
      id
    }
    updateChecklistItems(input: $updateChecklistItems) {
      id
    }
    deleteChecklistItems(input: $deleteChecklistItems) {
      id
    }
  }
`);

const useUpdateChecklistTask = (
  options?: UseMutationOptions<
    UpdateTaskMutation,
    unknown,
    {
      input: UpdateTaskInput;
      newChecklistItems: CreateChecklistItemsInput;
      updateChecklistItems: UpdateChecklistItemInput[];
      deleteChecklistItems: DeleteChecklistItemsInput;
    }
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_CHECKLIST_TASK_MUTATION, input);
    },
    ...options,
  });
};

export default useUpdateChecklistTask;
